import React, {useState} from "react";
import clsx from "clsx";
import isFunction from "lodash/isFunction";
import {withStyles} from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";


export const WhiteBorderedBox = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    borderColor: theme.palette.divider,
    borderWidth: 1,
    borderStyle: "solid",
    borderRadius: theme.shape.borderRadius
  },
}))(Box);

export const WhiteBox = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.shape.borderRadius
  },
}))(Box);

export const BackBox = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius
  },
}))(Box);

export const BackBorderedBox = withStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    borderRadius: theme.shape.borderRadius,
    borderColor: theme.palette.divider,
    borderWidth: 1,
    borderStyle: "solid",
  },
}))(Box);

export const HoverBox = withStyles((theme) => ({
  root: {
    cursor: "pointer",
    '&:hover': {
      backgroundColor: theme.palette.action.hover
    },
  },
}))(Box);

export const SelectableWhiteBox = withStyles((theme) => ({
  root: {
    cursor: "pointer",
    boxSizing: "border-box",
    backgroundColor: theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
    borderColor: theme.palette.common.white,
    borderWidth: 1,
    borderStyle: "solid",
    '&:hover': {
      borderColor: theme.palette.primary.selected,
    },
    '&.selected': {
      borderColor: theme.palette.primary.main,
    },
    '&.selected:hover': {
      borderColor: theme.palette.primary.main,
    },
  },

}))(React.forwardRef(({selected, ...props}, ref) => (
  <Box ref={ref}
       {...props}
       className={clsx({selected})}/>
)));



export const stopPropagation = (e) => e.stopPropagation();


export const DisplayOnHoverBox = ({children, ...props}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <Box {...props}
         onMouseEnter={() => setIsHovered(true)}
         onMouseLeave={() => setIsHovered(false)}>
      {isFunction(children) ? children(isHovered) : (isHovered && children)}
    </Box>
  );
};
